<div class="frame-container">
  <app-iframe
    title="Apache Superset"
    [url]="url"
  ></app-iframe>
</div>
